import React, { useRef, useState } from 'react'
import ReactModal from 'react-modal'
import { useNavigate, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import QrcodeBotGenerateModel from '../../../components/bots/manageBot/botShareModal/QrcodeBotGenerateModel'

const InstallBot = () => {
  const navigate = useNavigate()
  const [iscopied, setIscopied] = useState(false)
  const [isCopiedLink, setIsCopiedLink] = useState(false)
  const [isQrCodeModalOpen, setIsQrCodeModalOpen] = useState(false)
  const [qrCodeUrl, setQrCodeUrl] = useState<string>('')
  const textAreaRef = useRef<HTMLTextAreaElement | null>(null)
  const linkRef = useRef<HTMLInputElement | null>(null)
  const params = useParams()
  const appId = params.appId
  const deployementEnvironment = process.env.REACT_APP_DEPLOYMENT_ENVIRONMENT as string

  const openQrCodeModal = () => {
    setIsQrCodeModalOpen(true)
  }
  const closeQrCodeModal = () => {
    setIsQrCodeModalOpen(false)
  }

  const customModalStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      borderRadius: '15px',
      border: 'none',
      boxShadow: '0 2px 8px 0 #00000029'
    }
  }

  // Refactored previewUrl
  let environmentSuffix

  if (deployementEnvironment === 'prod') {
    environmentSuffix = 'live'
  } else {
    environmentSuffix = `live-${deployementEnvironment}`
  }

  const previewUrl = `https://${environmentSuffix}.botgo.io/?appId=${appId}`

  // Refactored scriptUrl
  let scriptEnvSuffix

  if (deployementEnvironment === 'prod') {
    scriptEnvSuffix = 'Prod'
  } else if (deployementEnvironment === 'demo') {
    scriptEnvSuffix = 'Demo'
  } else {
    scriptEnvSuffix = 'Dev'
  }

  const scriptUrl = `https://botgo.io/chatbotPlugin${scriptEnvSuffix}`

  const handleCopyCode = () => {
    if (botgoScript) {
      if (textAreaRef.current) {
        textAreaRef.current.select()
        document.execCommand('copy')
        setIscopied(true)
        toast.success('Code copied successfully!')
      }
    } else {
      toast.error('Cannot copy empty code!')
    }
  }

  const handleCopyLink = () => {
    if (linkRef.current) {
      linkRef.current.select()
      document.execCommand('copy')
      setIsCopiedLink(true)
      toast.success('Link copied successfully!')
    }
  }

  const botgoScript = `
  <script type="text/javascript">
    (function (d, m) {
      var botgoSettings = {
        "appId": ${appId},
        "botgo-primary-color": "",
        "botgo-bot-bubble-color": "",
        "botgo-header-height": "60px",
        "initiallyShow": true
      };
      var s = document.createElement("script"); s.type = "text/javascript"; s.async = true;
      var ts = Math.round(Date.now() / 1000);
      s.src = "${scriptUrl}/embedd.js?t=" + ts;
      var h = document.getElementsByTagName("head")[0]; h.appendChild(s);
      window.botgo = m;
      m._globals = botgoSettings;
    })(document, window.botgo || {});
  </script>
  `
  const handleNavigate = () => {
    window.history.back()
  }
  const generateQrCode = () => {
    // Update the URL structure to include the formId as a query parameter
    const qrCodeUrl = previewUrl
    setQrCodeUrl(qrCodeUrl)
    openQrCodeModal()
  }

  return (
    <section className='row p-4 deployement'>
      <div className='col-12 d-flex flex-column card rounded scroll-y h-800px'>
        <div className='row justify-content-center'>
          <div className='col-md-12'>
            <div className='card'>
              <div className='card-body'>
                <span className='mt-1 text-hover-primary' onClick={handleNavigate}>
                  <i className='bi bi-arrow-left' style={{ fontSize: '1.75rem' }}></i>
                </span>
                <h1 className='h1  lh-lg'>Install</h1>
                <ul
                  className='nav nav-stretch nav-line-tabs border-transparent flex-nowrap mb-5'
                  style={{ margin: 'auto' }}
                ></ul>
                <h2 className='card-subtitle-underline mb-4 '>
                  Follow the steps below to install Botgo Chat on your websites and web apps.
                </h2>
                <ul
                  className='nav nav-stretch nav-line-tabs border-transparent flex-nowrap mb-5'
                  style={{ margin: 'auto' }}
                ></ul>
                <div className='row'>
                  <div className='mb-3'>
                    <h3 className='fw-bold mb-3 '>Install Botgo on your website :</h3>
                    <p className='card-subtitle-1'>
                      Copy the JavaScript code below and paste it just before the closing {'<body>'}{' '}
                      tag on your website :
                    </p>
                    <div className='script' style={{ width: '70%' }}>
                      <div
                        className='textarea-container'
                        style={{ position: 'relative', display: 'flex' }}
                      >
                        <textarea
                          className='text-area'
                          dir='auto'
                          ref={textAreaRef}
                          value={botgoScript}
                          readOnly
                          rows={12}
                          style={{ flexGrow: 1 }}
                        />
                        <button
                          onClick={handleCopyCode}
                          className='copy-button'
                          style={{
                            color: iscopied ? 'green' : 'rgb(85, 83, 183)'
                          }}
                        >
                          <i
                            className={iscopied ? 'fas fa-check' : 'fas fa-copy'}
                            style={{
                              marginRight: '8px',
                              color: iscopied ? 'green' : 'rgb(85, 83, 183)'
                            }}
                          />
                          {iscopied ? 'Copied' : 'Copy'}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='row'>
                  <div className='mb-3'>
                    <h3 className='fw-bold mb-3 mt-6 '>Preview Botgo Link :</h3>
                    <p className='card-subtitle-1'>See preview of your bot :</p>
                    <div className='script' style={{ width: '70%' }}>
                      <div className='textarea-container d-flex' style={{ position: 'relative' }}>
                        <input
                          className='link-input'
                          type='text'
                          ref={linkRef}
                          value={previewUrl}
                          readOnly
                          style={{ flexGrow: 1 }}
                        />
                        <div className='d-flex'>
                          <button
                            onClick={handleCopyLink}
                            className='copy-button-1 '
                            style={{
                              color: isCopiedLink ? 'green' : 'rgb(85, 83, 183)'
                            }}
                          >
                            <i
                              className={isCopiedLink ? 'fas fa-check' : 'fas fa-copy'}
                              style={{
                                marginRight: '8px',
                                color: isCopiedLink ? 'green' : 'rgb(85, 83, 183)'
                              }}
                            />
                            {isCopiedLink ? 'Copied' : 'Copy'}
                          </button>

                          <button
                            className='link-button'
                            style={{
                              color: 'rgb(85, 83, 183)',
                              fontSize: '15px'
                            }}
                          >
                            <i
                              className='bi bi-link-45deg'
                              style={{
                                marginRight: '4px',
                                color: 'black'
                              }}
                            />
                            <a
                              href={previewUrl}
                              target='_blank'
                              rel='noreferrer'
                              style={{
                                color: 'rgb(85, 83, 183)',
                                fontSize: '15px'
                              }}
                            >
                              Preview
                            </a>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='row'>
                  <div className='mb-3'>
                    <h3 className='fw-bold mb-1 mt-6'>Preview Your Botgo QR Code:</h3>
                    <p className='card-subtitle-1'>Below is a preview of your bot:</p>

                    <div
                      className='script'
                      style={{
                        width: 'fit-content',
                        boxShadow: '0 2px 8px 0 #00000029',
                        borderRadius: '7px'
                      }}
                    >
                      {/* QR Code Generator Button */}
                      <button className='btn' onClick={generateQrCode}>
                        <img
                          alt='QR Code Generator'
                          className='social-link-icon'
                          src='https://upload.wikimedia.org/wikipedia/commons/1/11/Qr_code_QR-Code-Generator.png'
                          style={{ height: '40px' }}
                        />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ReactModal
        isOpen={isQrCodeModalOpen}
        onAfterOpen={() => {}}
        onRequestClose={closeQrCodeModal}
        style={customModalStyles}
        contentLabel='Qr Code Generate '
      >
        <QrcodeBotGenerateModel closeModal={closeQrCodeModal} qrCodeValue={qrCodeUrl} />
      </ReactModal>
      {iscopied && (
        <div
          className='toast'
          style={{ position: 'fixed', top: '10px', right: '10px', zIndex: 9999 }}
        >
          <div className='toast-header'>
            {iscopied ? 'Copy Success' : 'Copy Error'}
            <button type='button' className='btn-close' onClick={() => setIscopied(false)} />
          </div>
          <div className='toast-body'>
            {iscopied ? 'Code copied successfully!' : 'Sorry! Unexpected Error.'}
          </div>
        </div>
      )}
      {isCopiedLink && (
        <div
          className='toast'
          style={{ position: 'fixed', top: '70px', right: '10px', zIndex: 9999 }}
        >
          <div className='toast-header'>
            {isCopiedLink ? 'Link Copy Success' : 'Link Copy Error'}
            <button type='button' className='btn-close' onClick={() => setIsCopiedLink(false)} />
          </div>
          <div className='toast-body'>
            {isCopiedLink ? 'Link copied successfully!' : 'Sorry! Unexpected Error copying link.'}
          </div>
        </div>
      )}
    </section>
  )
}

export default InstallBot
